import styled from 'styled-components';

const Strut = styled.div`
    flex: 1;
`;

export default Strut;